
<script>
    import { Tooltip } from 'sveltestrap';
    
    import { formatDate } from '../date-time.js';

    export let inmateUrn;
    export let unit;
    export let wing;
    export let cell;
    export let cellStartDate = undefined;
    export let cellFinishDate = undefined;
    export let highlight = false;
</script>

<td>
    {#if wing}
        <span id="wing-data-{inmateUrn}">{wing}</span>
        {#if unit}
            <Tooltip target="wing-data-{inmateUrn}" placement="bottom">
                {unit}
            </Tooltip>
        {/if}
    {/if}
    {#if wing && cell}&nbsp;&middot;&nbsp;{/if}
    {#if cell}
        <span id="cell-data-{inmateUrn}" class:table-data-highlighted={highlight}>
            {cell}
        </span>
        {#if cellStartDate}
            <Tooltip target="cell-data-{inmateUrn}" placement="bottom">                                           
                {#if cellFinishDate}
                    {formatDate(cellStartDate)} to {formatDate(cellFinishDate)}
                {:else}
                    Since {formatDate(cellStartDate)}
                {/if}
            </Tooltip>
        {/if}
    {/if}
</td>